<!-- BEGIN PRELOADER -->
<div *ngIf="loadingOverlay" (click)="loadingOverlay = false;" class="loader-overlay" style="opacity: 0.8;">
  <div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</div>
<!-- END PRELOADER -->

<div class="header">
  <h2>Dettaglio <strong>Convenzione</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li><a style="cursor: pointer;" [routerLink]="['/contract']">Convenzioni</a></li>
      <li class="active">Dettaglio Convenzione</li>
    </ol>
  </div>
</div>
<div class="row">
  <div class="col-md-5">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-list"></i>Informazioni <strong>Convenzione</strong></h3>
      </div>
      <div class="panel-content">
        <h4><i class="fa fa-key"></i> <strong>Codice:</strong> {{ contract?.code }}</h4>
        <h4><i class="fa fa-info-circle"></i> <strong>Nome:</strong> {{ contract?.name }}</h4>
        <h4><i class="fa fa-dropbox"></i> <strong>Oggetto della Fornitura:</strong> {{ contract?.subject }}</h4>
        <h4><i class="fa fa-file-text-o"></i> <strong>Fornitore:</strong> {{ contract?.contract_founder?.name }}</h4>
        <h4><i class="fa fa-check-circle-o"></i> <strong>Checklist:</strong> {{ contract?.checklist?.name }}</h4>
        <h4><i class="fa fa-list"></i> <strong>Lotto:</strong> {{ contract?.lot }}</h4>
        <h4><i class="fa fa-calendar"></i> <strong>Data Inizio:</strong> {{ contract?.start | date: 'dd/MM/yyyy' }}</h4>
        <h4><i class="fa fa-calendar"></i> <strong>Data Fine:</strong> {{ contract?.end | date: 'dd/MM/yyyy' }}</h4>
      </div>
      <div *ngIf="user.fk_id_role <= 1" class="panel-footer">
        <a *ngIf="inspectionsGeneralState" class="btn btn-primary" (click)="openGenerateReport()"><i class="icon-doc"></i> Relazione</a>
        <a class="btn btn-blue" [routerLink]="['/contract/update/' + contract.id_contract]"><i class="icon-pencil"></i> Modifica</a>
        <a class="btn btn-danger" (click)="openDeleteContractModal()"><i class="icon-trash"></i> Elimina</a>
      </div>
    </div>
  </div>
  <div class="col-md-7">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-list"></i><strong>Indicatori</strong></h3>
      </div>
      <div class="panel-content">
        <table *ngIf="checklistCategoryIndicators.length > 0" class="table table-hover">
          <thead>
          <tr>
            <th style="width: 10%;">Codice</th>
            <th style="width: 75%;">Titolo</th>
            <th style="width: 15%;">Indicatore</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let checklistCategoryIndicator of checklistCategoryIndicators |
                  paginate: paginationConfig">
            <td>{{ checklistCategoryIndicator.checklist_category.code }}</td>
            <td>{{ checklistCategoryIndicator.checklist_category.name }}</td>
            <td>
              <input type="number"
                     step="0.1"
                     id="indicator"
                     name="indicator"
                     class="form-control"
                     required
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(indicator.valid || indicator.pristine)
                     }"
                     [(ngModel)]="checklistCategoryIndicator.value"
                     #indicator="ngModel">
            </td>
          </tr>
          </tbody>
        </table>
        <div *ngIf="checklistCategoryIndicators.length > 0">
          <pagination-controls (pageChange)="pageChanged($event)"
                               [autoHide]="paginationParams.autoHide"
                               [maxSize]="paginationParams.maxSize"
                               [responsive]="paginationParams.responsive"
                               [previousLabel]="paginationLabels.previousLabel"
                               [nextLabel]="paginationLabels.nextLabel"
                               [screenReaderPaginationLabel]="paginationLabels.screenReaderPaginationLabel"
                               [screenReaderPageLabel]="paginationLabels.screenReaderPageLabel"
                               [screenReaderCurrentLabel]="paginationLabels.screenReaderCurrentLabel"
          ></pagination-controls>
        </div>
        <div *ngIf="checklistCategoryIndicators.length === 0" style="text-align: center; height: 150px; padding-top: 60px;">
          Nessun indicatore associato.
        </div>
      </div>
      <div *ngIf="user.fk_id_role <= 1" class="panel-footer">
        <a class="btn btn-success" (click)="updateChecklistCategoryIndicators()"><i class="glyphicon glyphicon-floppy-save"></i> Salva</a>
      </div>
    </div>
  </div>
</div>
